module.exports = __webpack_public_path__ + "static/media/mine_banner.00ab4412.png";